<template>
   <div>
        <label><input hidden type="file" accept="application/pdf,image/jpeg" :id="inputId" ref="files" multiple v-on:change="handleFilesUpload()"/></label>
             <div class="listfiles">
                <div v-for="(file, index) in files" :key="index" >
                  <div class="fileitem">
                  <div class="filename">
                     <span class="fileiconecontainer">
                       <span class="icon-file-filled"></span>
                    </span>
                    <span class="filenamecontainer">
                      {{ file.name }}
                      <span class="smalltext greytext"> {{title}} </span>
                    </span>

                  </div>
                    <div class="action">
                          <span  v-on:click="readFile(file.name)" class="icon-download imgactionfile right"></span>
                          <span  v-on:click="removeFile(file.name)" class="icon-trash imgactionfile right"></span>
                    </div>
                  </div>
                </div>

             </div>
           <div ref="uploadDiv" v-if="canUploadFile" v-on:click="addfiles()" class="uploadfile">
             <div class="descriptionupload">
               <span class="icon-upload"></span>
               <div class="descriptionuploadcontent">
                <p>{{$t('File.FileAttachment.FILE_SELECTION_ACTIONS_ERROR')}}</p>
                <p>{{$t('File.FileAttachment.FILE_NAME_CONSTRAINTS_ERROR')}}</p>
                <p>{{$t('File.FileAttachment.FILE_CHARACTERISTICS_ERROR')}}</p>
               </div>

             </div>
           </div>
           <div id="downloadFiles" style="visibility:hidden">

           </div>
           <br/>
           <br/>
           <p v-if="errorfile" class="errorMessage">{{fileErrorMessage}}</p>
    </div>
</template>
<script>
export default {
  props: ['inputId', 'files', 'title', 'isRequired', 'checkFileName', 'maxFilesCount'],
  data () {
    return {
      errorfile: false,
      fileErrorMessage: '',
      fileMandatroy: this.$t('File.FileAttachment.FILE_MANDATROY_ERROR'),
      fileFormatInvalid: this.$t('File.FileAttachment.FILE_FORMAT_INVALID_ERROR'),
      fileTooBig: this.$t('File.FileAttachment.FILE_TOO_BIG_ERROR'),
      fileNameAlreadyExists: this.$t('File.FileAttachment.FILE_NAME_ALREADY_EXISTS_ERROR'),
      fileNameRegex: this.$t('File.FileAttachment.FILE_NAME_REGEX_ERROR'),
      canUploadFile: true
    }
  },
  methods: {
    addfiles () {
      this.$refs.files.click()
    },
    handleFilesUpload () {
      this.treatFileErrorUpload(this.$refs.files.files)
      this.$refs.files.value = null
    },
    treatFileErrorUpload (uploadedFiles) {
      this.errorfile = false
      this.uploadedFiles = true
      for (var i = 0; i < uploadedFiles.length; i++) {
        var isAlloweded = this.isFileExtensionAllowded(uploadedFiles[i].name)
        if (!isAlloweded) {
          this.errorfile = true
          this.fileErrorMessage = this.fileFormatInvalid
          return
        }
        var isFileTooBig = this.isFileTooBig(uploadedFiles[i].size)
        if (isFileTooBig) {
          this.errorfile = true
          this.fileErrorMessage = this.fileTooBig
          return
        }

        var isFileNameValid = this.isFileNameValid(uploadedFiles[i].name)
        if (!isFileNameValid) {
          this.errorfile = true
          this.fileErrorMessage = this.fileNameRegex
          return
        }
        var isFileExistsWithSameName = this.checkFileName(uploadedFiles[i].name)
        if (isFileExistsWithSameName) {
          this.errorfile = true
          this.fileErrorMessage = this.fileNameAlreadyExists
          return
        }
        this.files.push(uploadedFiles[i])
        this.canUploadFile = this.files.length < this.maxFilesCount
      }
    },
    isFileExtensionAllowded (fileName) {
      var ext = fileName.substr(fileName.lastIndexOf('.') + 1)
      switch (ext.toUpperCase()) {
        case 'PDF':
        case 'JPEG':
        case 'JPG':
          return true
        default:
          return false
      }
    },
    isFileTooBig (size) {
      var FileSize = size / 1024 / 1024
      return FileSize > 5
    },
    isFileNameValid (fileName) {
      var name = fileName.split('.').slice(0, -1).join('.')
      var isvalid = /^[-a-zA-Z0-9_\s]+$/.test(name)
      return isvalid && name.length <= 30
    },
    removeFile (key) {
      var fileIndex = this.files.findIndex(c => c.name === key)
      this.files.splice(fileIndex, 1)
      this.canUploadFile = this.files.length < this.maxFilesCount
    },
    readFile (key) {
      var file = this.files.find(c => c.name === key)
      if (file) {
        var reader = new FileReader()
        reader.onload = function () {
          let a = document.createElement('a')
          a.href = reader.result
          a.download = file.name
          $('#downloadFiles').append(a)
          a.click()
          a.remove()
        }
        reader.readAsDataURL(file)
      }
    },
    validate () {
      if (this.isRequired && this.files.length === 0) {
        this.errorfile = true
        this.fileErrorMessage = this.fileMandatroy
        return false
      }
      return true
    },
    addDraggableEvents () {
      let draggableEventsList = ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop']
      let canDragAndDrop = this.isDraggableAndDroppable()

      if (canDragAndDrop) {
        draggableEventsList.forEach(function (evt) {
          /*
                    For each event add an event listener that prevents the default action
                    (opening the file in the browser) and stop the propagation of the event (so
                    no other elements open the file in the browser)
                */
          document.body.addEventListener(evt, function (e) {
            e.preventDefault()
            e.stopPropagation()
          }, false)
        })

        this.$refs.uploadDiv.addEventListener('drop', function (e) {
          this.treatFileErrorUpload(e.dataTransfer.files)
        }.bind(this))
      }
    },
    isDraggableAndDroppable () {
      const { uploadDiv } = this.$refs
      return (('draggable' in uploadDiv) ||
                ('ondragstart' in uploadDiv && 'ondrop' in uploadDiv)) &&
                'FormData' in window &&
                'FileReader' in window
    }
  },
  mounted () {
    this.addDraggableEvents()
  }
}
</script>
<style scoped>
.fileiconecontainer{
  padding-top: 7px;
  width: 20%;
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(212, 217, 225, 1.0);
  padding-left: 6px;
  height: 40px;
  max-width: 37px;
}

.fileitemseparator{
  padding-top: 13px;
}

.filenamecontainer {
  padding-left: 9px;
  padding-top: 3px;
  width: 80%;
}
.descriptionupload{
   background-position: top left;
   color: rgba(160, 166, 173, 1.0);
   font-size: 11.0px;
   display: inline-flex;
}

.descriptionupload p  {
  margin-bottom: 0px !important;
}
.uploadfile {
   padding: 30px 10px 20px 10px;
   width: 100%;
   min-height: 80px;
   border-radius: 5px;
   border: dotted 1px;
   display: inline-block;
   border-color: #bccaca;
   align-items: center;
   justify-content: center;
   cursor: pointer;
}

.filename {
  display: inline-flex;
  width: 70%;
}
.listfiles{
  padding-bottom:21px;
  padding-top: 10px;
}
.fileitem {
  display: inline-flex;
  width: 100%;
  padding-top: 16px;
}

</style>
